import {Injectable, signal, WritableSignal} from '@angular/core';
import { User, UserBranch } from '../../graphql/generated';
import { GraphqlService } from './graphql.service';
import { getUserByIdQuery, LIST_USER_BRANCH } from '../../graphql/queries/user';
import { createUserQuery, CREATE_USER_BRANCH, DELETE_USER_BRANCH, deleteUserQuery, updateUserQuery } from '../../graphql/mutations/user';
import {Router} from '@angular/router';
import {Observable, of} from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class UserService {
  user: WritableSignal<User> = signal({} as User);
  user$: Observable<User> = of({} as User);

  constructor(private graphqlService: GraphqlService,
              private router: Router) {
    const user = localStorage.getItem('user');
    this.setUser(user ? JSON.parse(user) : {} as User);
  }

  async getUserById(id: string): Promise<User> {
    const response = await this.graphqlService.runQuery(getUserByIdQuery, {
      id: id,
    });

    return response.get_user;
  }

  async createUser(user: User): Promise<User> {
    const response = await this.graphqlService.runMutation(createUserQuery, {
      user,
    });

    return response.create_user;
  }

  async updateUser(id: string, change: User) {
    return await this.graphqlService.runMutation(updateUserQuery, {
      id,
      change,
    });
  }

  async deleteUser(id: string) {
    return await this.graphqlService.runMutation(deleteUserQuery, {
      id,
    });
  }

  setUser(user: User): void {
    localStorage.setItem('user', JSON.stringify(user));
    this.user.set(user);
    this.user$ = of(user);
  }

  getUser(): User {
    return this.user();
  }

  logout(): void {
    localStorage.removeItem('user');
    this.setUser({} as User);
    this.router.navigate(['auth/login']).then();
  }

  async listUserBranch(userId: string): Promise<UserBranch[]> {
    const res = await this.graphqlService.runQuery(LIST_USER_BRANCH, {
      equal: userId,
    });
    return res.list_user_branch;
  }

  async deleteUserBranch(id: string) {
    const res = await this.graphqlService.runMutation(DELETE_USER_BRANCH, {
      id,
    });
    return res.delete_user_branch;
  }

  async createUserBranch(userBranch: UserBranch) {
    const res = await this.graphqlService.runMutation(CREATE_USER_BRANCH, {
      userBranch,
    });
    return res.create_user_branch;
  }
}
